import axios from "axios";
import { ElLoading, ElMessage } from 'element-plus'
import { useDemoStore } from '../../pinia/index'
import { getPayOrderApi } from './api.js'
import { watch } from 'vue'
const store = useDemoStore()

const service = axios.create({
  headers: { 'Content-Type': 'multipart/form-data' },
  baseURL: getPayOrderApi(),
  timeout: 30000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
});

watch(() => store.server, () => {
  service.defaults.baseURL = getPayOrderApi()
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 请求头添加token
    config.headers['Authorization'] = store.token;
    config.headers['Accept-Language'] = store.lang;
    config.headers["codeKey"] = store.codeKey;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.Status == 0 || res.Status == 200) {
      return res;
    } else {
      // ElMessage(res.Message);
      return res;
    }
  },
  (error) => {
    ElMessage(error.message);
    return Promise.reject(error.message);
  }
);
export default service;